import React from 'react'
import { Box, styled } from '@mui/system'

const StyledLoading = styled('div')(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#fff',
  flexDirection: 'column',
}))

const BottomLogo = styled('img')(() => ({
  position: 'absolute',
  bottom: 20,
  width: '100px',
  height: 'auto',
}))

const CenterGif = styled('img')(() => ({
  width: '120px',
  height: '120px',
  filter: 'grayscale(100%)',
  opacity: 0.5,

}))

const Loading = () => {
  return (
    <StyledLoading>
      <CenterGif
        src="https://res.cloudinary.com/doxlnd27h/image/upload/v1745981244/projectImages/GoVirtual-Logo-6366e481-5d2c-4e14-b1f6-83990a8c409e.gif"
        alt="Loading..."
      />
      <BottomLogo
        src="https://res.cloudinary.com/doxlnd27h/image/upload/v1745981444/projectImages/logotransparent-10241bf2-d355-4b53-b487-9602a2fce09c.png"
        alt="Bottom Logo"
      />
    </StyledLoading>
  )
}

export default Loading
